import { render, staticRenderFns } from "./check-info.vue?vue&type=template&id=22bc469a&scoped=true"
import script from "./check-info.vue?vue&type=script&lang=js"
export * from "./check-info.vue?vue&type=script&lang=js"
import style0 from "./check-info.vue?vue&type=style&index=0&id=22bc469a&prod&lang=scss&scoped=true"
import style1 from "./check-info.vue?vue&type=style&index=1&id=22bc469a&prod&lang=css"
import style2 from "./check-info.vue?vue&type=style&index=2&id=22bc469a&prod&lang=scss&scoped=true"
import style3 from "./check-info.vue?vue&type=style&index=3&id=22bc469a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc469a",
  null
  
)

export default component.exports